"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import * as _utils from "./utils";
import _styles from "./AlbertaFeatures.module.css";

const _interactionsData = JSON.parse(
  '{"events":{"e-391":{"id":"e-391","name":"","animationType":"custom","eventTypeId":"SCROLLING_IN_VIEW","action":{"id":"","actionTypeId":"GENERAL_CONTINUOUS_ACTION","config":{"actionListId":"a-18","affectedElements":{},"duration":0}},"mediaQueries":["main"],"target":{"id":"44959a8c-ed8d-4d44-d842-209aba04a7e6","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"44959a8c-ed8d-4d44-d842-209aba04a7e6","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":[{"continuousParameterGroupId":"a-18-p","smoothing":50,"startsEntering":true,"addStartOffset":false,"addOffsetValue":50,"startsExiting":false,"addEndOffset":false,"endOffsetValue":50}],"createdOn":1715723465681},"e-398":{"id":"e-398","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-399"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"44959a8c-ed8d-4d44-d842-209aba04a7ed","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"44959a8c-ed8d-4d44-d842-209aba04a7ed","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":100,"direction":"BOTTOM","effectIn":true},"createdOn":1716319495699},"e-400":{"id":"e-400","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInLeft","autoStopEventId":"e-401"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"44959a8c-ed8d-4d44-d842-209aba04a7ef","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"44959a8c-ed8d-4d44-d842-209aba04a7ef","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":200,"direction":"LEFT","effectIn":true},"createdOn":1716319509109},"e-402":{"id":"e-402","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-403"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"44959a8c-ed8d-4d44-d842-209aba04a81d","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"44959a8c-ed8d-4d44-d842-209aba04a81d","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":100,"direction":"BOTTOM","effectIn":true},"createdOn":1716319527820},"e-404":{"id":"e-404","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-405"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"44959a8c-ed8d-4d44-d842-209aba04a820","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"44959a8c-ed8d-4d44-d842-209aba04a820","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":200,"direction":"BOTTOM","effectIn":true},"createdOn":1716319567012},"e-406":{"id":"e-406","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-407"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"44959a8c-ed8d-4d44-d842-209aba04a822","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"44959a8c-ed8d-4d44-d842-209aba04a822","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":300,"direction":"BOTTOM","effectIn":true},"createdOn":1716319579681},"e-408":{"id":"e-408","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-409"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"44959a8c-ed8d-4d44-d842-209aba04a827","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"44959a8c-ed8d-4d44-d842-209aba04a827","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":400,"direction":"BOTTOM","effectIn":true},"createdOn":1716319595498},"e-410":{"id":"e-410","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-411"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"44959a8c-ed8d-4d44-d842-209aba04a82a","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"44959a8c-ed8d-4d44-d842-209aba04a82a","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":500,"direction":"BOTTOM","effectIn":true},"createdOn":1716319615970},"e-412":{"id":"e-412","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-413"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"44959a8c-ed8d-4d44-d842-209aba04a831","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"44959a8c-ed8d-4d44-d842-209aba04a831","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":100,"direction":"BOTTOM","effectIn":true},"createdOn":1716319633291},"e-414":{"id":"e-414","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-415"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"44959a8c-ed8d-4d44-d842-209aba04a834","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"44959a8c-ed8d-4d44-d842-209aba04a834","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":200,"direction":"BOTTOM","effectIn":true},"createdOn":1716319643229},"e-416":{"id":"e-416","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-417"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"44959a8c-ed8d-4d44-d842-209aba04a836","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"44959a8c-ed8d-4d44-d842-209aba04a836","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":300,"direction":"BOTTOM","effectIn":true},"createdOn":1716319657165},"e-418":{"id":"e-418","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-419"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"44959a8c-ed8d-4d44-d842-209aba04a83a","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"44959a8c-ed8d-4d44-d842-209aba04a83a","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":400,"direction":"BOTTOM","effectIn":true},"createdOn":1716319671043},"e-420":{"id":"e-420","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-421"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"44959a8c-ed8d-4d44-d842-209aba04a840","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"44959a8c-ed8d-4d44-d842-209aba04a840","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":100,"direction":"BOTTOM","effectIn":true},"createdOn":1716319685344},"e-422":{"id":"e-422","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-423"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"44959a8c-ed8d-4d44-d842-209aba04a843","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"44959a8c-ed8d-4d44-d842-209aba04a843","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":200,"direction":"BOTTOM","effectIn":true},"createdOn":1716319695363},"e-424":{"id":"e-424","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-425"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"44959a8c-ed8d-4d44-d842-209aba04a845","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"44959a8c-ed8d-4d44-d842-209aba04a845","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":300,"direction":"BOTTOM","effectIn":true},"createdOn":1716319713141},"e-426":{"id":"e-426","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-427"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"44959a8c-ed8d-4d44-d842-209aba04a84c","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"44959a8c-ed8d-4d44-d842-209aba04a84c","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":100,"direction":"BOTTOM","effectIn":true},"createdOn":1716319728480},"e-428":{"id":"e-428","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-429"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"44959a8c-ed8d-4d44-d842-209aba04a84e","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"44959a8c-ed8d-4d44-d842-209aba04a84e","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":200,"direction":"BOTTOM","effectIn":true},"createdOn":1716319739421},"e-482":{"id":"e-482","name":"","animationType":"custom","eventTypeId":"PAGE_START","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-23","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-483"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"wf-page-id","appliesTo":"PAGE","styleBlockIds":[]},"targets":[{"id":"wf-page-id","appliesTo":"PAGE","styleBlockIds":[]}],"config":{"loop":true,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1716505315197}},"actionLists":{"a-18":{"id":"a-18","title":"alberta_features-scroll","continuousParameterGroups":[{"id":"a-18-p","type":"SCROLL_PROGRESS","parameterLabel":"Scroll","continuousActionGroups":[{"keyframe":58,"actionItems":[{"id":"a-18-n-8","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".alberta_features-img._1","selectorGuids":["daec58b2-0eb6-8d61-459e-83d249a53e78","daec58b2-0eb6-8d61-459e-83d249a53e82"]},"value":1,"unit":""}}]},{"keyframe":68,"actionItems":[{"id":"a-18-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".alberta_features-img._1","selectorGuids":["daec58b2-0eb6-8d61-459e-83d249a53e78","daec58b2-0eb6-8d61-459e-83d249a53e82"]},"value":0,"unit":""}}]},{"keyframe":72,"actionItems":[{"id":"a-18-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".alberta_features-img._2","selectorGuids":["daec58b2-0eb6-8d61-459e-83d249a53e78","daec58b2-0eb6-8d61-459e-83d249a53e83"]},"value":1,"unit":""}}]},{"keyframe":78,"actionItems":[{"id":"a-18-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".alberta_features-img._2","selectorGuids":["daec58b2-0eb6-8d61-459e-83d249a53e78","daec58b2-0eb6-8d61-459e-83d249a53e83"]},"value":0,"unit":""}}]}]}],"createdOn":1715726893642},"a-23":{"id":"a-23","title":"skeleton-loader","actionItemGroups":[{"actionItems":[{"id":"a-23-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".skeleton-loader-animation","selectorGuids":["8f7e00cc-0b33-d9e9-3cb0-9ba1d827d7cf"]},"xValue":-100,"xUnit":"%","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"id":"a-23-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":1000,"easing":"","duration":800,"target":{"selector":".skeleton-loader-animation","selectorGuids":["8f7e00cc-0b33-d9e9-3cb0-9ba1d827d7cf"]},"xValue":250,"xUnit":"%","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"id":"a-23-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":100,"target":{"selector":".skeleton-loader-animation","selectorGuids":["8f7e00cc-0b33-d9e9-3cb0-9ba1d827d7cf"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-23-n-4","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":100,"target":{"selector":".skeleton-loader-animation","selectorGuids":["8f7e00cc-0b33-d9e9-3cb0-9ba1d827d7cf"]},"xValue":-100,"xUnit":"%","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"id":"a-23-n-5","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":100,"target":{"selector":".skeleton-loader-animation","selectorGuids":["8f7e00cc-0b33-d9e9-3cb0-9ba1d827d7cf"]},"value":1,"unit":""}}]},{"actionItems":[{"id":"a-23-n-6","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":800,"target":{"selector":".skeleton-loader-animation","selectorGuids":["8f7e00cc-0b33-d9e9-3cb0-9ba1d827d7cf"]},"xValue":250,"xUnit":"%","yUnit":"PX","zUnit":"PX"}}]}],"useFirstGroupAsInitialState":true,"createdOn":1716505320174},"slideInBottom":{"id":"slideInBottom","useFirstGroupAsInitialState":true,"actionItemGroups":[{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":0}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":100,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":0,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}},{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":1}}]}]},"slideInLeft":{"id":"slideInLeft","useFirstGroupAsInitialState":true,"actionItemGroups":[{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":0}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":-100,"yValue":0,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":1}},{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":0,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]}]}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function AlbertaFeatures({ as: _Component = _Builtin.Section }) {
  _interactions.useInteractions(_interactionsData, _styles);

  return (
    <_Component
      className={_utils.cx(_styles, "alberta_section-features")}
      data-w-id="44959a8c-ed8d-4d44-d842-209aba04a7e6"
      grid={{
        type: "section",
      }}
      tag="section"
    >
      <_Builtin.Block
        className={_utils.cx(_styles, "container-large")}
        tag="div"
      >
        <_Builtin.Block
          className={_utils.cx(_styles, "padding-section-medium")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "padding-global")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(
                _styles,
                "alberta_features-container",
                "max-width-xxlarge",
                "align-center"
              )}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(
                  _styles,
                  "alberta_features-heading",
                  "text-align-center"
                )}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(
                    _styles,
                    "alberta_features-heading-container"
                  )}
                  tag="div"
                >
                  <_Builtin.Heading
                    className={_utils.cx(_styles, "alberta_features-heading")}
                    data-w-id="44959a8c-ed8d-4d44-d842-209aba04a7ed"
                    tag="h3"
                  >
                    {"Marketing, tenant screening & more – all in one place"}
                  </_Builtin.Heading>
                  <_Builtin.Paragraph
                    className={_utils.cx(_styles, "text-color-secondary")}
                    data-w-id="44959a8c-ed8d-4d44-d842-209aba04a7ef"
                  >
                    {
                      "Get your listing rented faster with time-saving solutions from listing to signing."
                    }
                  </_Builtin.Paragraph>
                </_Builtin.Block>
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "alberta_features-grid-copy")}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "alberta_features-column")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "alberta_features-img-wrap")}
                    tag="div"
                  >
                    <_Builtin.Image
                      className={_utils.cx(
                        _styles,
                        "alberta_features-img",
                        "_1"
                      )}
                      loading="lazy"
                      width="auto"
                      height="auto"
                      alt=""
                      src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/6643e7b2574a9a0f739626be_screening-trust-score.webp"
                    />
                    <_Builtin.Image
                      className={_utils.cx(
                        _styles,
                        "alberta_features-img",
                        "_2"
                      )}
                      loading="lazy"
                      width="auto"
                      height="auto"
                      alt=""
                      src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/6643df653439c8b0c0e3acc4_sponsored-listings.webp"
                    />
                    <_Builtin.Image
                      className={_utils.cx(
                        _styles,
                        "alberta_features-img",
                        "_3"
                      )}
                      loading="lazy"
                      width="auto"
                      height="auto"
                      alt="renter application"
                      src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/6643df65a7d2124856d9720f_applications.webp"
                    />
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "alberta_features-column")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(
                      _styles,
                      "alberta_features-copy-container"
                    )}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "alberta_features-img-tablet-down"
                      )}
                      tag="div"
                    >
                      <_Builtin.Block
                        className={_utils.cx(
                          _styles,
                          "alberta_features-img",
                          "_1",
                          "hide-tablet"
                        )}
                        tag="div"
                      >
                        <_Builtin.BackgroundVideoWrapper
                          tag="div"
                          sources={[
                            "https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/6643e489b4c9f5557d4160eb_screening-trust-score-transcode.webm",
                            "https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/6643e489b4c9f5557d4160eb_screening-trust-score-transcode.mp4",
                          ]}
                          posterImage="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/6643e489b4c9f5557d4160eb_screening-trust-score-poster-00001.jpg"
                          autoPlay={true}
                          loop={true}
                        />
                      </_Builtin.Block>
                      <_Builtin.Image
                        className={_utils.cx(
                          _styles,
                          "alberta_features-img",
                          "_1"
                        )}
                        loading="lazy"
                        width="auto"
                        height="auto"
                        alt=""
                        src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/6643e7b2574a9a0f739626be_screening-trust-score.webp"
                      />
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(_styles, "alberta_features-copy")}
                      tag="div"
                    >
                      <_Builtin.Paragraph
                        className={_utils.cx(_styles, "subheading-style")}
                      >
                        {"Tenant Screening"}
                      </_Builtin.Paragraph>
                      <_Builtin.Heading tag="h3">
                        {"More than just a credit check"}
                      </_Builtin.Heading>
                      <_Builtin.Paragraph
                        className={_utils.cx(_styles, "text-color-secondary")}
                      >
                        {
                          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat."
                        }
                      </_Builtin.Paragraph>
                    </_Builtin.Block>
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(
                      _styles,
                      "alberta_features-copy-container"
                    )}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "alberta_features-img-tablet-down"
                      )}
                      tag="div"
                    >
                      <_Builtin.Image
                        className={_utils.cx(
                          _styles,
                          "alberta_features-img",
                          "_2"
                        )}
                        loading="lazy"
                        width="auto"
                        height="auto"
                        alt=""
                        src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/6643df653439c8b0c0e3acc4_sponsored-listings.webp"
                      />
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(_styles, "alberta_features-copy")}
                      tag="div"
                    >
                      <_Builtin.Paragraph
                        className={_utils.cx(_styles, "subheading-style")}
                      >
                        {"sponsored listings"}
                      </_Builtin.Paragraph>
                      <_Builtin.Heading tag="h3">
                        {"Get up to 300% views"}
                      </_Builtin.Heading>
                      <_Builtin.Paragraph
                        className={_utils.cx(_styles, "text-color-secondary")}
                      >
                        {
                          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat."
                        }
                      </_Builtin.Paragraph>
                    </_Builtin.Block>
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(
                      _styles,
                      "alberta_features-copy-container"
                    )}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "alberta_features-img-tablet-down"
                      )}
                      tag="div"
                    >
                      <_Builtin.Image
                        className={_utils.cx(
                          _styles,
                          "alberta_features-img",
                          "_3"
                        )}
                        loading="lazy"
                        width="auto"
                        height="auto"
                        alt="renter application"
                        src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/6643df65a7d2124856d9720f_applications.webp"
                      />
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(_styles, "alberta_features-copy")}
                      tag="div"
                    >
                      <_Builtin.Paragraph
                        className={_utils.cx(_styles, "subheading-style")}
                      >
                        {"applications"}
                      </_Builtin.Paragraph>
                      <_Builtin.Heading tag="h3">
                        {"Streamlined applications"}
                      </_Builtin.Heading>
                      <_Builtin.Paragraph
                        className={_utils.cx(_styles, "text-color-secondary")}
                      >
                        {
                          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat."
                        }
                      </_Builtin.Paragraph>
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Block>
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "alberta_features-grid")}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(
                    _styles,
                    "alberta_features-video-container"
                  )}
                  id={_utils.cx(
                    _styles,
                    "w-node-_44959a8c-ed8d-4d44-d842-209aba04a819-ba04a7e6"
                  )}
                  tag="div"
                >
                  <_Builtin.BackgroundVideoWrapper
                    className={_utils.cx(_styles, "alberta_features-image")}
                    tag="div"
                    id="videoScreening"
                    sources={[
                      "https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef%2F66906028ebbf8e61d27bfab6_screening-trust-score-livrent-transcode.webm",
                      "https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef%2F66906028ebbf8e61d27bfab6_screening-trust-score-livrent-transcode.mp4",
                    ]}
                    posterImage="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef%2F66906028ebbf8e61d27bfab6_screening-trust-score-livrent-poster-00001.jpg"
                    autoPlay={true}
                    loop={true}
                  />
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(
                    _styles,
                    "alberta_features-copy-container"
                  )}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "alberta_features-copy")}
                    tag="div"
                  >
                    <_Builtin.Paragraph
                      className={_utils.cx(_styles, "subheading-style")}
                      data-w-id="44959a8c-ed8d-4d44-d842-209aba04a81d"
                    >
                      {"Tenant Screening"}
                    </_Builtin.Paragraph>
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "albera_features-copy-wrap"
                      )}
                      tag="div"
                    >
                      <_Builtin.Heading
                        className={_utils.cx(_styles, "margin-0")}
                        data-w-id="44959a8c-ed8d-4d44-d842-209aba04a820"
                        tag="h3"
                      >
                        {"Identify the perfect tenants"}
                      </_Builtin.Heading>
                      <_Builtin.Paragraph
                        className={_utils.cx(_styles, "text-color-secondary")}
                        data-w-id="44959a8c-ed8d-4d44-d842-209aba04a822"
                      >
                        {
                          "Take the guesswork out of tenant screening with the Trust Score. Unlock applicants' report to view Equifax® credit information, income & employment verification, and more."
                        }
                        <br />
                      </_Builtin.Paragraph>
                      <_Builtin.Block
                        className={_utils.cx(
                          _styles,
                          "alberta_features-copy-promo"
                        )}
                        tag="div"
                      >
                        <_Builtin.Paragraph
                          className={_utils.cx(
                            _styles,
                            "alberta_features-promo-text"
                          )}
                          data-w-id="44959a8c-ed8d-4d44-d842-209aba04a827"
                        >
                          {
                            "Growth plan includes 2 reports per month, saving $408 per year."
                          }
                          <br />
                        </_Builtin.Paragraph>
                      </_Builtin.Block>
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(_styles, "equifax-wrapper")}
                      data-w-id="44959a8c-ed8d-4d44-d842-209aba04a82a"
                      tag="div"
                    >
                      <_Builtin.Paragraph
                        className={_utils.cx(_styles, "equifax-text")}
                      >
                        {"Powered by:"}
                      </_Builtin.Paragraph>
                      <_Builtin.Image
                        className={_utils.cx(_styles, "equifax-logo")}
                        loading="lazy"
                        width="106"
                        height="auto"
                        alt=""
                        src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/664781d5471c493faf34d3f9_equifax-logo.webp"
                      />
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Image
                  className={_utils.cx(_styles, "alberta_features-image")}
                  loading="lazy"
                  width="auto"
                  height="auto"
                  alt="advertising rental property facebook craigslist"
                  src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/6647d5a915614ddc8c5766be_syndication.webp"
                />
                <_Builtin.Block
                  className={_utils.cx(
                    _styles,
                    "alberta_features-copy-container"
                  )}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "alberta_features-copy")}
                    tag="div"
                  >
                    <_Builtin.Paragraph
                      className={_utils.cx(_styles, "subheading-style")}
                      data-w-id="44959a8c-ed8d-4d44-d842-209aba04a831"
                    >
                      {"Rental marketing"}
                    </_Builtin.Paragraph>
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "alberta_other-features-copy-wrap"
                      )}
                      tag="div"
                    >
                      <_Builtin.Heading
                        className={_utils.cx(_styles, "margin-0")}
                        data-w-id="44959a8c-ed8d-4d44-d842-209aba04a834"
                        tag="h3"
                      >
                        {"Get more qualified leads"}
                      </_Builtin.Heading>
                      <_Builtin.Paragraph
                        className={_utils.cx(_styles, "text-color-secondary")}
                        data-w-id="44959a8c-ed8d-4d44-d842-209aba04a836"
                      >
                        {
                          "Automate your tenant search with Multi-Platform Advertising by liv.rent. Our team will share your listing to Craigslist and Facebook Marketplace, managing inquiries and directing applicants to your liv.rent listing."
                        }
                      </_Builtin.Paragraph>
                      <_Builtin.Block
                        className={_utils.cx(
                          _styles,
                          "alberta_features-copy-promo"
                        )}
                        tag="div"
                      >
                        <_Builtin.Paragraph
                          className={_utils.cx(
                            _styles,
                            "alberta_features-promo-text"
                          )}
                          data-w-id="44959a8c-ed8d-4d44-d842-209aba04a83a"
                        >
                          {
                            "Growth plan includes 2 ads per month, saving $168 per year."
                          }
                          <br />
                        </_Builtin.Paragraph>
                      </_Builtin.Block>
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Image
                  className={_utils.cx(_styles, "alberta_features-image")}
                  loading="lazy"
                  width="auto"
                  height="auto"
                  alt="renter application"
                  src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/6643df65a7d2124856d9720f_applications.webp"
                />
                <_Builtin.Block
                  className={_utils.cx(
                    _styles,
                    "alberta_features-copy-container"
                  )}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "alberta_features-copy")}
                    tag="div"
                  >
                    <_Builtin.Paragraph
                      className={_utils.cx(_styles, "subheading-style")}
                      data-w-id="44959a8c-ed8d-4d44-d842-209aba04a840"
                    >
                      {"applications"}
                    </_Builtin.Paragraph>
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "alberta_features-copy-wrap"
                      )}
                      tag="div"
                    >
                      <_Builtin.Heading
                        className={_utils.cx(_styles, "margin-0")}
                        data-w-id="44959a8c-ed8d-4d44-d842-209aba04a843"
                        tag="h3"
                      >
                        {"Streamlined applications"}
                      </_Builtin.Heading>
                      <_Builtin.Paragraph
                        className={_utils.cx(_styles, "text-color-secondary")}
                        data-w-id="44959a8c-ed8d-4d44-d842-209aba04a845"
                      >
                        {
                          "Receive & respond to inquiries and applications all in one secure location with built-in instant chat. Save your favourite applications to stay organized, and use the Trust Score to screen applicants right within liv.rent."
                        }
                      </_Builtin.Paragraph>
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Block>
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(
                  _styles,
                  "alberta_cta-card",
                  "max-width-xxlarge",
                  "align-center"
                )}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(
                    _styles,
                    "alberta_cta-copy-wrap",
                    "max-width-medium"
                  )}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(
                      _styles,
                      "alberta_cta-heading",
                      "heading-style-h4"
                    )}
                    data-w-id="44959a8c-ed8d-4d44-d842-209aba04a84c"
                    tag="div"
                  >
                    {"👋 Alberta Landlords - Try our Growth Plan for free"}
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(_styles, "albberta_cta-description")}
                    data-w-id="44959a8c-ed8d-4d44-d842-209aba04a84e"
                    tag="div"
                  >
                    {"We invite you to celebrate our launch to Alberta with a "}
                    <_Builtin.Strong>
                      {"free 1-month trial to our Growth Plan"}
                    </_Builtin.Strong>
                    {"*"}
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "alberta_cta-form-card")}
                  tag="div"
                  id="alberta_features-cta-form"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "skeleton-loader")}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "skeleton-loader-animation"
                      )}
                      tag="div"
                    />
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "alberta_cta-ribbon-wrap")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "alberta_cta-ribbon")}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(_styles, "alberta_cta-ribbon-text")}
                      tag="div"
                    >
                      {"exclusive offer"}
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
    </_Component>
  );
}
